// Pedido a la API que espera JSON: devuelve el cuerpo, y ok:false o un error
// HTTP se convierten en excepción con el mensaje del servidor. Era el `req()`
// copiado en Recorridos y en el Baúl.
//
// Va en su propio archivo y no dentro de authFetch.ts a propósito: las pruebas
// mockean ese módulo entero (`{ authFetch: jest.fn() }`), y desde acá este
// helper sigue andando sobre el authFetch falso sin tocar ninguna prueba.
import { authFetch } from "./authFetch";

export type JsonInit = { method?: string; body?: unknown };
// Lo que reciben los componentes que piden cosas a la API (ya con el token).
export type Req = (path: string, init?: JsonInit) => Promise<any>;

export async function requestJson(path: string, { token, method = "GET", body }: JsonInit & { token?: string | null } = {}): Promise<any> {
  const response = await authFetch(path, { token, method, json: body !== undefined, body: body === undefined ? undefined : JSON.stringify(body) });
  const json = await response.json().catch(() => ({}));
  // El error lleva el código HTTP: la cola de escaneo se corta ante un 401.
  if (!response.ok || json?.ok === false) throw Object.assign(new Error(json?.error || json?.message || `Error ${response.status}`), { status: response.status });
  return json;
}
